<template>
  <div class="customer-satisfaction">
    <p class="customer-satisfaction__header" v-html="header"></p>

    <div v-show="!showThanks">
      <label class="tla-form-group__label">{{ratingLabel}}</label>

      <div class="tla-form-group__touch-points">
        <touchpoint v-for="(item) in options"
          :key="item.touchpointValue"
          :collectionName="'csatRating'"
          :inputId="item.touchpointValue"
          :inputValue="item.touchpointValue"
          :isFullWidth="true"
          :isSelected="item.preSelect"
          @csatRating="submitCsatRating($event)">
          <div class="customer-satisfaction__text" slot="touchpoint" v-html="item.touchpointName"></div>
        </touchpoint>
      </div>

      <div class="tla-form-group">
        <label class="tla-form-group__label">{{tellUsLabel}}</label>
        <textarea v-model="csatText" class="tla-form-group__textarea" :placeholder="tellUsPlaceholder"></textarea>
        <div class="customer-satisfaction__microcopy" v-html="tellUsMicrocopy"></div>
      </div>

      <button
        class="btn tla-btn tla-btn--info"
        @click="submitCsatText"
        type="button"
        name="csat-submit-button"
        id="csat-submit-button">
        {{submitText}}
      </button>
    </div>

    <div v-show="showThanks" class="customer-satisfaction__box">
      <p class="customer-satisfaction__thanks">Thanks for your feedback</p>
      <div class="thanks__tick"></div>
      <p class="customer-satisfaction__header" v-html="thanksText"></p>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Inject
} from 'vue-property-decorator';
import {
  Action, namespace
} from 'vuex-class';
import Touchpoint from '@/models/Touchpoint';
import VeeValidate, { FieldError, Validator } from 'vee-validate';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import ExtraData from '../../models/ExtraData';

const PostEnquiryModule = namespace('postEnquiryModule');

@Component({
  components: {
  touchpoint: GenericTouchPointComponent
  }
  })
export default class CustomerSatisfactionComponent extends Vue {
  @PostEnquiryModule.Action public submitEnquiryExtraData;

  @Prop({ default: 'How would you <span> rate your overall satisfaction </span> with the service you received today?' })
  public header!: string;

  @Prop({ default: 'Select your overall satisfaction' })
  public ratingLabel!: string;

  @Prop({ default: 'Tell us about your experience' })
  public tellUsLabel!: string;

  @Prop({ default: 'We’d love to hear your thoughts…' })
  public tellUsPlaceholder!: string;

  @Prop({ default: '' })
  public tellUsMicrocopy!: string;

  @Prop({ default: 'Send Feedback' })
  public submitText!: string;

  public showThanks: boolean = false;

  public thanksText: string = 'Our goal is to create the <span>best possible service</span>, and your thoughts, ideas, and suggestions play a major role in helping us identify opportunities to improve.';

  public csatText: string = '';

  public options: Touchpoint[] = [
    new Touchpoint('5', `<img src="${this.imagePath}/very-satisfied.svg"/> Very satisfied`),
    new Touchpoint('4', `<img src="${this.imagePath}/satisfied.svg"/> Satisfied`),
    new Touchpoint('3', `<img src="${this.imagePath}/neither.svg"/> Neither satisfied / dissatisfied`),
    new Touchpoint('2', `<img src="${this.imagePath}/dissatisfied.svg"/> Somewhat dissatisfied`),
    new Touchpoint('1', `<img src="${this.imagePath}/very-dissatisfied.svg"/> Very dissatisfied`)
  ];

  public submitCsatRating(value: string) {
    const data: ExtraData[] = [
      {
        keyName: 'tlaCsatRating',
        keyValue: value
      }
    ];

    this.submitEnquiryExtraData(data);
  }

  public submitCsatText() {
    this.showThanks = true;
    if (this.csatText && this.csatText.length > 0) {
      const data: ExtraData[] = [
        {
          keyName: 'tlaCsatText',
          keyValue: this.csatText
        }
      ];
      this.submitEnquiryExtraData(data);
    }
  }

  public preSelect(value: string) {
    const touchpointItem = this.options.find((x) => x.touchpointValue === value);
    if (touchpointItem) {
      touchpointItem.preSelect = true;
    }
  }

  public queryStringCheck() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const value = urlParams.get('tlaCsatRating');
      if (value && this.options.some((x) => x.touchpointValue === value)) {
        this.preSelect(value);
        this.submitCsatRating(value);
      }
    } catch (error) {
      console.log('URLSearchParams not supoorted');
    }
  }

  public get imagePath() {
    return `${process.env.BASE_URL}images/customer-satisfaction`;
  }

  public created() {
    this.queryStringCheck();
  }
}
</script>
